import React, { useState } from 'react'
import "./AdaptorTab.css"
import md from "../../images/medal-fill.svg"
import { IMG_URL } from '../../config';


function AdaptorTab({ebook}) {

const [activeTab, setActiveTab] = useState('about');

const handleRedirect = (link) => {

      if (!link) return;

      window.location.href = link;

  };

return (
<div className="adaptor-container">

      <ul className="adaptor-tabs-nav">
        <li 
          className={activeTab === 'about' ? 'active' : ''} 
          onClick={() => setActiveTab('about')}
        >
          {ebook?.book_detail?.about_book_title}
        </li>
        <li 
          className={activeTab === 'who' ? 'active' : ''} 
          onClick={() => setActiveTab('who')}
        >
          {ebook?.book_detail?.who_is_for_title}
        </li>
        <li 
          className={activeTab === 'related' ? 'active' : ''} 
          onClick={() => setActiveTab('related')}
        >
          {ebook?.book_detail?.related_book_title}
        </li>
      </ul>

      {/* Tab Content Window */}
      <div className="adaptor-tab-content-row">
        
        {/* Left Column: Text description changes based on active tab */}
        <div className="adaptor-content-left">

          {activeTab === 'about' && (
            
            <div dangerouslySetInnerHTML={{__html:ebook?.about_book}} />
        
          )}
          {activeTab === 'who' && (

            <div dangerouslySetInnerHTML={{__html:ebook?.who_is_for}} />

          )}
          {activeTab === 'related' && (

            <div dangerouslySetInnerHTML={{__html:ebook?.related_book}} />

          )}
        </div>

        <div className="adaptor-card-right">
          <div className="card-badge-icon">

            <span><img src={`${IMG_URL}/d0/${ebook?.book_detail?.unlock_ebook_subcrition_image}`} alt="" /></span>

              <h4>{ebook?.book_detail?.unlock_ebook_subcrition_title}</h4> 

          </div>
        
          <div dangerouslySetInnerHTML={{__html:ebook?.book_detail?.unlock_ebook_subcription_content}} />
          
          <div className="card-actions">

            <button className="btn-explore"  onClick={() => handleRedirect(ebook?.book_detail?.explore_ebook_subcripiton_link)} > {ebook?.book_detail?.explore_ebook_subcripiton_label} </button>

            <button className="btn-quiz" onClick={() => handleRedirect(ebook?.book_detail?.unlock_ebook_take_quiz_link)} > {ebook?.book_detail?.unlock_ebook_take_quiz_label} </button>

          </div>
        </div>

      </div>
    </div>
  )
}

export default AdaptorTab